import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import type { CircularProgressProps } from '@mui/material/CircularProgress';

interface LoaderProps extends CircularProgressProps {
  size?: number | string;
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning' | 'inherit';
}

const Loader: React.FC<LoaderProps> = ({ size = 20, color, ...rest }) => {
  return <CircularProgress size={size} color={color} {...rest} />;
};

export default Loader;
